import { useState } from "react";
import { Box } from "@mui/material";
import { styledComponent } from "../utils/styled";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useTheme } from "../context/ThemeContext";
import { SidebarProvider } from "../context/SidebarContext";

// ── Styled components ────────────────────────────────────────────────────────

const LayoutRoot = styledComponent(Box)(({ isDark }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "row",
  backgroundColor: isDark ? "#171819" : "#FCFDFF",
}));

const ContentArea = styledComponent(Box)({
  flex: 1,
  overflow: "hidden",
  height: "100%",
  display: "flex",
});

// ── Component ────────────────────────────────────────────────────────────────

export default function SidebarLayout() {
  const { isDark } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { pathname } = useLocation();
  const hideSidebar = pathname.startsWith("/model");

  return (
    <LayoutRoot isDark={isDark}>
      {!hideSidebar && (
        <Sidebar
          open={sidebarOpen}
          closeSidebar={() => setSidebarOpen(false)}
          openSidebar={() => setSidebarOpen(true)}
        />
      )}

      <ContentArea>
        <SidebarProvider
          value={{ sidebarOpen, openSidebar: () => setSidebarOpen(true) }}
        >
          <Outlet />
        </SidebarProvider>
      </ContentArea>
    </LayoutRoot>
  );
}
